import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export const DataStaleBanner = () => {
  const { user } = useAuth();
  const [s, setS] = useState(null);
  useEffect(() => {
    if (user?.role === "superadmin") api.get("/data-status").then((r) => setS(r.data)).catch(() => {});
  }, [user?.role]);
  if (!s?.stale) return null;
  const d = s.last_date.split("-").reverse().join("/");
  return (
    <div data-testid="data-stale-banner" className="flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-800 sm:px-8">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>Dati fermi: gli ultimi scontrini ricevuti sono del <b>{d}</b> ({s.days} giorni fa). Verifica l'invio dei dati al database.</span>
    </div>
  );
};
